// manage gift message and sync to cart note
function getGiftNote(container) {
  var to = container.querySelector('[id$="gift-to"]')?.value || '';
  var from = container.querySelector('[id$="gift-from"]')?.value || '';
  var msg = container.querySelector('[id$="gift-message"]')?.value || '';
  var giftNote = 'To: ' + to + '\n' + 'From: ' + from + '\n' + 'Note: ' + msg + '\n';
  return giftNote;
}

function sanitize(value) {
  var blockSpecialRegex = /[^a-zA-Z\d\s:]/g;
  return (value || '').replace(blockSpecialRegex, '');
}

function postNote(note) {
  $s.post({
    type: 'POST',
    url: '/cart/update.js',
    data: {"note": note},
    dataType: 'json',
    success: async function(cart) {}
  });
}

function postUpdate(data) {
  $s.post({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: async function(cart) {}
  });
}

export function initGiftMessage(container) {
  if (!container || container.__giftMessageInitialized) { return; }
  container.__giftMessageInitialized = true;

  var checkbox = container.querySelector('input[type="checkbox"]');
  var label = container.querySelector('.chk-instructions-label');
  var noteWrapper = container.querySelector('.instructions');
  var toInput = container.querySelector('[id$="gift-to"]');
  var fromInput = container.querySelector('[id$="gift-from"]');
  var msgInput = container.querySelector('[id$="gift-message"]');

  if (!checkbox || !noteWrapper || !toInput || !fromInput || !msgInput) { return; }

  function getValues() {
    return {
      to: toInput.value || '',
      from: fromInput.value || '',
      msg: msgInput.value || ''
    };
  }

  function setValues(values) {
    if (!values) { return; }
    if (typeof values.to === 'string') { toInput.value = values.to; }
    if (typeof values.from === 'string') { fromInput.value = values.from; }
    if (typeof values.msg === 'string') { msgInput.value = values.msg; }
  }

  function buildPayload(checked, values) {
    if (checked) {
      var note = 'To: ' + values.to + '\n' + 'From: ' + values.from + '\n' + 'Note: ' + values.msg + '\n';
      return {
        note: note,
        attributes: {
          'gift-to': values.to,
          'gift-from': values.from,
          'gift-message': values.msg
        }
      };
    } else {
      return {
        note: '',
        attributes: {
          'gift-to': '',
          'gift-from': '',
          'gift-message': ''
        }
      };
    }
  }

  function maybePost(payload) {
    var snapshot = JSON.stringify(payload);
    if (container.__lastPostedSnapshot === snapshot) { return; }
    container.__lastPostedSnapshot = snapshot;
    window.__giftNoteLast = payload.note;
    postUpdate(payload);
  }

  // initialize memory with current values
  container.__giftMessageValues = getValues();

  var applyChange = function(evt) {
    if (evt && evt.target) {
      evt.target.value = sanitize(evt.target.value);
    }
    // always keep memory up to date even when hidden
    container.__giftMessageValues = getValues();
    if (!checkbox.checked) { return; }
    var payload = buildPayload(true, container.__giftMessageValues);
    maybePost(payload);
  };

  if (label) {
    label.addEventListener('keypress', function(event) {
      if (event.keyCode == 13) {
        checkbox.click();
      }
    });
  }

  checkbox.addEventListener('click', function() {
    if (checkbox.checked) {
      noteWrapper.style.display = 'block';
      // restore last values if inputs got reset by a rerender/toggle
      if (container.__giftMessageValues) {
        var hasCurrent =
          (toInput.value && toInput.value.length) ||
          (fromInput.value && fromInput.value.length) ||
          (msgInput.value && msgInput.value.length);
        if (!hasCurrent) {
          setValues(container.__giftMessageValues);
        }
      }
      // post current state (note + attributes) when showing again
      var payloadChecked = buildPayload(true, getValues());
      maybePost(payloadChecked);
    } else {
      noteWrapper.style.display = 'none';
      // keep current input values and memory; do not post empty note when hidden
      container.__giftMessageValues = getValues();
      // clear backend note and attributes while preserving UI values
      var payloadUnchecked = buildPayload(false, container.__giftMessageValues);
      maybePost(payloadUnchecked);
    }
  });

  [toInput, fromInput, msgInput].forEach(function(el){
    el.addEventListener('change', applyChange);
  });

  if (checkbox.checked) {
    noteWrapper.style.display = 'block';
  } else {
    noteWrapper.style.display = 'none';
  }
}